import { render, staticRenderFns } from "./BankPayway.vue?vue&type=template&id=86dd5c8c&scoped=true&"
import script from "./BankPayway.vue?vue&type=script&lang=js&"
export * from "./BankPayway.vue?vue&type=script&lang=js&"
import style0 from "./BankPayway.vue?vue&type=style&index=0&id=86dd5c8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86dd5c8c",
  null
  
)

export default component.exports